<template>
  <div id="contenedor">
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-card class="table" elevation="4">
          <v-toolbar flat elevation="4">
            <v-card class="icon">
              <v-icon
                style="margin-left: 30px; margin-top: 25px"
                color="white"
                x-large=""
                >mdi-alert</v-icon
              >
            </v-card>
            <div class="usuario">¡PANICO!</div>
            <audio v-if="estado == 1" autoplay loop>
              <source src="../../assets/alerta-sonido.mp3" type="audio/mp3" />
            </audio>
          </v-toolbar>
          <br />
          <v-dialog v-model="dialog2" max-width="300px">
            <v-card>
              <div></div>
              <v-card-title class="nav">
                <span class="headline" style="color: white"
                  ><v-icon color="white">mdi-eye</v-icon> OBSERVACION</span
                >
              </v-card-title>
              <!-- componente del modal para agregar y actualizar -->
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12>
                      <p>{{ observacionSeleccionada }}</p>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <!-- botones para cancelar y agregregar y validacion de campos vacios -->
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1D3C7F" @click="close1">OK</v-btn>
              </v-card-actions>
              <!-- <pre>{{editedItem}}</pre>  -->
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialog1" max-width="700px">
            <v-card>
              <div></div>
              <v-card-title class="nav">
                <span class="headline" style="color: white"
                  ><v-icon color="white">mdi-account</v-icon> ATENCION AL
                  PUNTO</span
                >
              </v-card-title>
              <!-- componente del modal para agregar y actualizar -->
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12>
                      <v-textarea v-model="editedItem.observacion" color="teal">
                        <template v-slot:label>
                          <div>Observacion</div>
                        </template>
                      </v-textarea>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <!-- botones para cancelar y agregregar y validacion de campos vacios -->
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1D3C7F" @click="close">Cancelar</v-btn>
                <v-btn
                  color="#1D3C7F"
                  @click="atender"
                  :disabled="!editedItem.observacion"
                  >Guardar</v-btn
                >
              </v-card-actions>
              <!-- <pre>{{editedItem}}</pre>  -->
            </v-card>
          </v-dialog>
          <v-dialog fullscreen v-model="dialog" persistent>
            <v-card
              color="rgba(255,0,0,0.4)"
              style="display: flex;align-items: center;justify-content: center;"
            >
              <div id="cont-alert">
                <img
                  class="mb-7 mr-8"
                  src="../../assets/warning.gif"
                  style="height: 200px; width: 200px"
                  alt=""
                />
                <p>se activo la alarma de <strong>¡PANICO!</strong></p>
                <p><strong>ip: </strong>{{ ipActual }}</p>
                <p><strong>municipio: </strong>{{ municipioActual }}</p>
                <p><strong>punto: </strong>{{ puntoActual }}</p>
                <v-btn style="height: 3em; width: 5em" @click="parar()"
                  >ok</v-btn
                >
              </div>
            </v-card>
          </v-dialog>
          <br />
          <v-data-table
            :headers="headers"
            :items="alertas"
            style="border: 2px solid #111c3d"
            class="elevation-3"
          >
            <!-- tabla donde se pintan los datos obtenidos del arreglo -->
            <template v-slot:[`item.action`]="{ item }">
              <v-btn v-if="item.estado == 0 || item.estado == 1" @click="editItem(item)"
                >atender
                <v-icon color="red" medium class="mr-2"> mdi-alert </v-icon>
              </v-btn>
              <v-icon
                v-if="item.estado == 2"
                medium
                class="mr-2"
                color="green"
                @click="obs(item)"
              >
                mdi-eye
              </v-icon>
            </template>
            <template v-slot:no-data>
              <v-alert :value="true" color="#111c3d" icon="mdi-alert" outlined
                >No se encontro su busqueda</v-alert
              >
            </template>
          </v-data-table>
          <!-- alertas de las acciones que se hacen -->
          <v-snackbar
            v-model="snackbar"
            :bottom="y === 'bottom'"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :right="x === 'right'"
            :timeout="timeout"
            :top="y === 'top'"
            :vertical="mode === 'vertical'"
            color="#294697"
            style="color: white"
          >
            {{ text }}
            <v-btn color="#294697" depressed @click="snackbar = false"
              >Cerrar</v-btn
            >
          </v-snackbar>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import env from "../env";
export default {
  data() {
    return {
      show: false,
      snackbar: false,
      y: "top",
      x: null,
      mode: "",
      timeout: 6000,
      text: "",
      dialog: false,
      dialog1: false,
      dialog2: false,
      idEdit: "",
      idActual: "",
      idPanico: "",
      municipioActual: "",
      puntoActual: "",
      observacionSeleccionada: "",
      estado: 0,
      ipActual: "",
      text: "",
      alertas: [],
      headers: [
        {
          text: "ID",
          align: "left",
          value: "idPanico",
          align: "center",
          class: "column",
        },
        {
          text: "IP",
          value: "ip",
          align: "center",
          class: "column",
        },
        {
          text: "Fecha",
          value: "fechaPanico",
          align: "center",
          class: "column",
        },
        {
          text: "Acciones",
          value: "action",
          sortable: false,
          align: "center",
          class: "column",
        },
      ],
      defaultItem: {
        observacion: "",
      },
      editedIndex: -1,
      editedItem: {
        observacion: "",
      },
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Punto" : "Editar Punto";
    },
  },
  mounted() {
    this.panico();
    setInterval(() => {
      this.panico();
    }, 10000);
  },

  methods: {
    // Metodo para obtener las alertas
    panico() {
      axios
        .get(`${env.endpoint}callcenter/panico`)
        .then((res) => {
          this.alertas = res.data;
          res.data.map( item => {
            item.estado === "1" ? this.confirmacion(item) : null
          })
        });
    },
    editItem(item) {
      this.idEdit = item.idPanico;
      this.dialog1 = true;
    },

    //metodo para abrir modal de alerta
    confirmacion( alerta ) {
      this.estado = alerta.estado;
      this.ipActual = alerta.ip;
      this.idPanico = alerta.idPanico;
      this.municipioActual = alerta.municipio;
      this.puntoActual = alerta.punto;
      this.idActual = alerta.idPanico;

      if (this.estado == 1) {
        this.dialog = true;
        //console.log("alerta");
      }
    },
    //metodo para cerrar la modal
    parar() {
      this.estado = 0;
      axios
        .get(
          `${env.endpoint}callcenter/panicoAtencion?idPanico=${this.idPanico}`
        )
        .then((res) => (this.report = res.data));
      this.dialog = false;
    },
    atender() {
      axios
        .get(
          `${env.endpoint}callcenter/panicoRespuesta?idPanico=${this.idEdit}&observacion=${this.editedItem.observacion}`
        )
        .then((res) => (this.report = res.data));
      this.editedItem.observacion = "";
      this.dialog1 = false;

      this.panico();
    },
    obs(item) {
      this.observacionSeleccionada = item.observacion;
      this.dialog2 = true;
    },
    close() {
      this.dialog1 = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    close1() {
      this.dialog2 = false;
      this.observacionSeleccionada = "";
    },
  },
};
</script>

<style>
#cont-alert {
  border: 5px solid white;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 550px;
  width: 550px;
  color: white;
  background-color: red;
  font-size: 2em;
  padding: 1em;
}

</style>
